import React from 'react';

import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

export const StyledPlaceHolderOverlayWrapper = styled('div')({
	position: 'relative',
	width: '100%',
	height: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	overflow: 'hidden',
});

export const StyledPlaceHolderOverlay = styled('div')({
	position: 'absolute',
	inset: 0,
	background: 'rgba(255, 255, 255, 0.8)',
	backdropFilter: 'blur(2px)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	textAlign: 'center',
	zIndex: 10,
});

export const StyledPlaceHolderChildContent = styled('div')({
	filter: 'blur(4px)',
	pointerEvents: 'none',
	width: '100%',
	overflow: 'hidden',
});

export const StyledPlaceholderTooltip = styled(
	// @TODO: Check it
	({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />,
)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		padding: '4px 8px',
		borderRadius: '4px',
		background: '#fff',
		color: theme.palette.text.secondary,
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: '#fff',
	},
}));
